import { createActionGroup, props } from "@ngrx/store";
import { DiscountTypes } from "graphql.generated";

import { ActionSource } from "../../state/action-sources";

export const JobMutateDiscountActions = createActionGroup({
  source: ActionSource.MUTATE_DISCOUNT_DIALOG,
  events: {
    'Discount Name Input Changed': props<{ discountName: string }>(),
    'Amount Input Changed': props<{ amount: number }>(),
    'Discount Type Selected': props<{ discountType: DiscountTypes }>(),
    'Event Selection Changed': props<{ eventIds: string[] }>(),
  },
})
